import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, CircularProgress } from "@mui/material";
import { getCupones, getLocales, getSorteos } from "../../../api/ApiService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CuponesTableComponent from "./components/CuponesTableComponent";
import FitrosCupones from "./components/FitrosCupones";



function CuponesPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);

    const [dataCupones, setDataCupones] = useState([]);

    // Sorteos
    const [dataSorteos, setDataSorteos] = useState([]);
    const [sorteoSelected, setSorteoSelected] = useState(null);
    const [loadingCargarSorteo, setLoadingCargarSorteo] = useState(false);

    // Locales
    const [dataLocales, setDataLocales] = useState([]);
    const [localSelected, setLocalSelected] = useState(null);

    // Filtros
    const [ci, setCi] = useState('');
    const [fechaProcDesde, setFechaProcDesde] = useState('');
    const [fechaProcHasta, setFechaProcHasta] = useState('');
    const [fechaFacturaDesde, setFechaFacturaDesde] = useState('');
    const [fechaFacturaHasta, setFechaFacturaHasta] = useState('');

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1,
    });
    const [perPage, setPerPage] = useState(10);

    const stateToken = useSelector(state => state.reducerGlobal.token);
    const history = useNavigate();

    useEffect(() => {
        if (stateToken) {
            handleCargarLocales();
            handleCargarSorteos('');
        }
    }, [stateToken]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (ci.length > 2) {

                handleApiFiltrarCupones(1);
            } else {
                handleApiFiltrarCupones(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);

    }, [stateToken, ci, sorteoSelected, localSelected, fechaProcDesde, fechaProcHasta, fechaFacturaDesde, fechaFacturaHasta, perPage]);



    const handleCargarLocales = () => {
        getLocales(stateToken?.access_token)
            .then((response) => {
                setDataLocales(response?.data?.length > 0 ? response.data : []);
            })
            .catch((error) => {
                console.log("error-getLocales", error);
                setDataLocales([]);
            });
    };

    const handleCargarSorteos = (titulo) => {
        setLoadingCargarSorteo(true);
        const body = {
            titulo: titulo || '',
            estado_promocion: '',
            estado_publicacion: '',
            page: 1,
            per_page: 50,
        };
        getSorteos(stateToken?.access_token, body)
            .then((response) => {
                setLoadingCargarSorteo(false);
                setDataSorteos(response?.data || []);
            })
            .catch((error) => {
                console.log("error-getSorteos", error);
                setLoadingCargarSorteo(false);
                setDataSorteos([]);
            });
    };

    const handleApiFiltrarCupones = (page = 1) => {
        const body = {
            page,
            per_page: perPage,
            sorteo_id: sorteoSelected?.id ?? '',
            ci,
            local_id: localSelected?.id ?? '',
            fecha_procesamiento_desde: fechaProcDesde,
            fecha_procesamiento_hasta: fechaProcHasta,
            fecha_factura_desde: fechaFacturaDesde,
            fecha_factura_hasta: fechaFacturaHasta,
        };
        setLoadingCargar(true);
        getCupones(stateToken?.access_token, body)
            .then((response) => {
                setLoadingCargar(false);
                setDataCupones(response?.data || []);
                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page,
                });
            })
            .catch((error) => {
                console.log("error-getCupones", error);
                setDataCupones([]);
                setLoadingCargar(false);
            });
    };

    const handleEditarItem = (item) => {
        console.log("item", item);
        history(`/app/admin/cupon-detalle/${item?.id_para_detalle}`);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <FitrosCupones
                    title="Cupones"
                    ci={ci}
                    handleCi={setCi}
                    dataSorteos={dataSorteos}
                    sorteoSelected={sorteoSelected}
                    handleSorteoSelected={setSorteoSelected}
                    handleSorteoSearch={handleCargarSorteos}
                    loadingCargarSorteo={loadingCargarSorteo}
                    dataLocales={dataLocales}
                    localSelected={localSelected}
                    handleLocalSelected={setLocalSelected}
                    fechaProcDesde={fechaProcDesde}
                    handleFechaProcDesde={setFechaProcDesde}
                    fechaProcHasta={fechaProcHasta}
                    handleFechaProcHasta={setFechaProcHasta}
                    fechaFacturaDesde={fechaFacturaDesde}
                    handleFechaFacturaDesde={setFechaFacturaDesde}
                    fechaFacturaHasta={fechaFacturaHasta}
                    handleFechaFacturaHasta={setFechaFacturaHasta}
                    handleBuscar={() => handleApiFiltrarCupones(1)}
                />

                <CuponesTableComponent
                    data={dataCupones}
                    metaPaginacion={metaPaginacion}
                    onPageChange={handleApiFiltrarCupones}
                    perPage={perPage}
                    onPerPageChange={handlePerPageChange}
                    handleEditarItem={handleEditarItem}
                />

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default CuponesPage;
